import { render, staticRenderFns } from "./XinWenKeDetail.vue?vue&type=template&id=248eefbc&scoped=true"
import script from "./XinWenKeDetail.vue?vue&type=script&lang=js"
export * from "./XinWenKeDetail.vue?vue&type=script&lang=js"
import style0 from "./XinWenKeDetail.vue?vue&type=style&index=0&id=248eefbc&prod&scoped=true&lang=css"
import style1 from "./XinWenKeDetail.vue?vue&type=style&index=1&id=248eefbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248eefbc",
  null
  
)

export default component.exports